import { BehaviorSubject } from 'rxjs';
import { Injectable } from '@angular/core';

import { ThemeModeType } from '../../utils';
import { ThemeModeComponent } from '../../models/layout';
import { getThemeModeFromLocalStorage, systemMode, themeMenuModeLSKey, themeModeLSKey } from '../../constants';

@Injectable({
   providedIn: 'root',
})
export class ThemeModeService {
   public mode: BehaviorSubject<ThemeModeType> = new BehaviorSubject<ThemeModeType>(getThemeModeFromLocalStorage(themeModeLSKey));
   public menuMode: BehaviorSubject<ThemeModeType> = new BehaviorSubject<ThemeModeType>(getThemeModeFromLocalStorage(themeMenuModeLSKey));

   public updateMode(_mode: ThemeModeType) {
      const updatedMode = _mode === 'system' ? systemMode : _mode;
      this.mode.next(updatedMode);
      // themeModeSwitchHelper(updatedMode)
      if (localStorage) {
         localStorage.setItem(themeModeLSKey, updatedMode);
      }

      document?.documentElement.setAttribute('data-theme', updatedMode);
      ThemeModeComponent.init();
   }

   public updateMenuMode(_menuMode: ThemeModeType) {
      this.menuMode.next(_menuMode);
      if (localStorage) {
         localStorage.setItem(themeMenuModeLSKey, _menuMode);
      }
   }

   public init() {
      this.updateMode(this.mode.value);
      this.updateMenuMode(this.menuMode.value);
   }

   public switchMode(_mode: ThemeModeType) {
      if (localStorage) {
         const updatedMode = _mode === 'system' ? systemMode : _mode;
         localStorage.setItem(themeModeLSKey, updatedMode);
         localStorage.setItem(themeMenuModeLSKey, _mode);
      }
      document?.location.reload()
   }
}
